import { useState, useEffect } from 'react'
import axios from 'axios'
import type { ChartDataResponse } from '@shared/common-types.js'
import type { ChartConfigIdType } from '@shared/constants.js'
import { appApiUrls } from '@shared/url-map.js'

export function useChartData(chartId: ChartConfigIdType) {
  const [data, setData] = useState<ChartDataResponse | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    const controller = new AbortController()
    setLoading(true)
    setError(null)
    axios
      .get(appApiUrls.locationChart, { params: { id: chartId }, signal: controller.signal })
      .then((res) => {
        if (res.data.code === 0) {
          setData(res.data.data)
        } else {
          setError(new Error(res.data.msg))
        }
      })
      .catch((e) => {
        if (!axios.isCancel(e)) {
          setError(e)
        }
      })
      .finally(() => {
        setLoading(false)
      })
    return () => controller.abort()
  }, [chartId])

  return { data, loading, error }
}
